<template>
    <v-app class="dsp-2022-cycle">
        <dsp-header></dsp-header>
        <sidebar v-if="$vuetify.breakpoint.mdAndUp"></sidebar>
        <v-main 
            app
            class="white">
            <router-view
                :show-stats="mini"
                :narrative-stats="narrativeStats"
                :state-stats="stateStats">
            </router-view>
        </v-main>
        <dsp-footer></dsp-footer>
    </v-app>
</template>

<script>
    import { narrativeStats } from "./constants/narrativeStats";
    import stateStats from "./constants/stateStats.json";
    import dspFooter from "./components/dspFooter";
    import dspHeader from "./components/header/dspHeader";
    import Sidebar from "./components/navigation/Sidebar";

    export default {
        name: 'dsp-2022-cycle',
        components: { 
            dspFooter,
            dspHeader,
            Sidebar,
        },
        data(){
            return {
                mini: false,
                narrativeStats: narrativeStats,
                stateStats: stateStats,
            }
        },
    };
</script>
<style lang="scss">
    @import "./styles/_variables.scss";
    .dsp-2022-cycle{
        font-family: 'Libre Franklin';
        position: absolute;
        width: 100%;

        /* Hide scrollbar for Chrome, Safari and Opera */
        *::-webkit-scrollbar {
            display: none;
        }

        /* Hide scrollbar for IE, Edge and Firefox */
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
     
        &__breadcrumbs{
            position: fixed;
            width: 100%;
            z-index: 1;
        }

        &__site-description{
            font-size: 12px;
            line-height: 14px;
            max-width: 500px;
        }

        .v-avatar svg{
            height: initial;
            width: initial;
        }
        .dsp-button{
            font-weight: bold;
            font-family: 'Libre Franklin';
            letter-spacing: 1px;
        }

        .v-breadcrumbs{
            padding: 8px;
            
        }
        .v-breadcrumbs__item{
            background-color: transparent;
            padding: 8px 12px;
            border-radius: 3px;

            &:not(.v-breadcrumbs__item--disabled){
                color: $primary;
                &:hover{
                    background-color: #e7ebee;
                    cursor: pointer;
                }
            }
        }
        .v-bottom-navigation.v-item-group .v-btn{
            min-width: 0px;
            flex: 1;
            padding: 0px;
        }
    }
</style>
